/**
 * Yönetici servisi — yetki sistemine geçiş.
 *
 * Mimari:
 *  - BOSS hariç tüm kullanıcılar rol='personel'
 *  - Yönetici yetkisi olanlar yoneticiMi:true + yoneticiYetkileri[]
 *  - Auth hesabı email/şifre ile
 *
 * Cloud Functions:
 *  - yoneticiYetkileriGuncelle: BOSS personeli yönetici yapar / yetki ekler/kaldırır / Auth oluşturur/siler
 */

import { httpsCallable } from 'firebase/functions'
import { getFirebaseFunctions } from '@/lib/firebase'
import type { YetkiId } from '@/lib/yetkiler'

export interface YoneticiYetkileriGuncelleData {
  /** Hedef personelin Firestore doc ID'si (yönetici hesabı için Auth UID olur) */
  uid: string
  /** Yönetici yetkisi açık mı? false ise Auth hesabı silinir, yetkiler kaldırılır */
  yoneticiMi: boolean
  /** Yönetici ise: granular yetki listesi */
  yoneticiYetkileri?: YetkiId[]
  /** Yönetici ise: login email'i */
  email?: string
  /** Yönetici ise (yeni hesap veya şifre değişimi): şifre (min 6) */
  sifre?: string
}

export async function yoneticiYetkileriGuncelle(
  data: YoneticiYetkileriGuncelleData
): Promise<void> {
  const fn = httpsCallable<YoneticiYetkileriGuncelleData, { ok: boolean }>(
    getFirebaseFunctions(),
    'yoneticiYetkileriGuncelle'
  )
  await fn(data)
}

export interface YoneticiPersonelEkleData {
  email: string
  sifre: string
  yetkiler: YetkiId[]
  personel: {
    isim: string
    telefon: string
    dogumTarihi: string
    iseBaslamaTarihi: string
    adres?: string
    acilIletisim?: { isim: string; telefon: string }
    pozisyonIdleri: string[]
    subeIdleri: string[]
    calismaTipi: 'fulltime' | 'parttime'
    takvimTipi: 'market' | 'ofis'
    maasTipi: 'saatlik' | 'aylik'
    ucret: number
    fazlaMesaiKatsayisi: 1 | 1.5 | 2
    aylikStandartSaat: number
    sabitEkOdeme: number
    sabitKesinti: number
    ibanNo?: string
    yillikIzinBaslangicBakiye: number
    whatsappBildirimi: boolean
  }
}

/** Atomik: yeni personel + yönetici hesabı tek seferde — Auth çakışırsa hiçbir şey yazılmaz */
export async function yoneticiPersonelEkle(data: YoneticiPersonelEkleData): Promise<string> {
  const fn = httpsCallable<YoneticiPersonelEkleData, { uid: string; ok: boolean }>(
    getFirebaseFunctions(),
    'yoneticiPersonelEkle'
  )
  const sonuc = await fn(data)
  return sonuc.data.uid
}
